module.exports = __webpack_public_path__ + "static/playstore-736fbc206b7ca3b6afe9dc82dc04301c.svg";